import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useWarehouser from '../../../hooks/user/useWarehouser';
import useListWarehouses from '../../../hooks/warehouse/useListWarehouse';
import {
  IWarehouserRequest,
  WarehouserDataType,
  WarehouserInitialValues,
  WarehouserSchema,
} from '../../../models/user/warehouser.model';
import { getWarehouseRoles } from '../../../utils/utils';

const CreateWarehouserModal = () => {
  const { createWarehouser, loading } = useWarehouser();
  const { listOfWarehouses } = useListWarehouses();

  const onSubmit = (values: WarehouserDataType, actions: any) => {
    // console.log(values);
    const data: IWarehouserRequest = {
      ...values,
      phoneNumber: '234' + values.phoneNumber.slice(1),
      role: getWarehouseRoles(values.role),
      warehouseId: listOfWarehouses.filter(
        (data: any) => data.name === values.warehouseId
      )[0].id,
    };

    createWarehouser(data);

    // if (resetInputFields) {
    actions.resetForm(WarehouserInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Warehouser'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={WarehouserInitialValues}
          schema={WarehouserSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="First Name"
            name="firstName"
            type="text"
            placeholder="First Name"
            className="full"
          />
          <TextInputField
            label="Last Name"
            name="lastName"
            type="text"
            placeholder="Last Name"
            className="full"
          />
          <TextInputField
            label="Username"
            name="userName"
            type="text"
            placeholder="Username"
            className="full"
          />

          <TextInputField
            label="Email"
            name="email"
            type="email"
            placeholder="Email"
            className="full"
          />
          <TextInputField
            label="Phone Number"
            name="phoneNumber"
            type="text"
            placeholder="Phone Number"
            className="full"
          />

          <SelectField label="Warehouse" name="warehouseId">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Warehouse'}
            </option>
            {listOfWarehouses &&
              listOfWarehouses.map((data: any, index: number) => (
                <option key={index}>{data.name}</option>
              ))}
          </SelectField>

          <SelectField label="Role" name="role">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Role'}
            </option>
            <option>Warehouse Admin</option>
            <option>Warehouse User</option>
            <option>Warehouse Manager</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Warehouser
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateWarehouserModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
